<template>
    <div id="new-talent">
        <div class="breadcrumb">达人管理 >
            <span>新增达人账号</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
                <el-button class="right_f" type="primary" @click="saveTalent">保存</el-button>
            </span>
        </div>
        <div class="talent-box">
            <el-form ref="talentForm" :rules="rules" :model="talentForm" label-width="130px">
                <el-form-item label="手机号：" prop="phoneNumber">
                    <el-input v-model="talentForm.phoneNumber" @blur="sendPhoneToCheck" placeholder="请输入手机号"
                        class="talentTitle"></el-input>
                    <span class="err-msg">{{errorMsg}}</span>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="talentForm.name" :disabled="true" class="talentTitle"></el-input>
                </el-form-item>
                <el-form-item label="校区：" prop="zoneName">
                    <el-input v-model="talentForm.zoneName" :disabled="true" class="talentTitle"></el-input>
                </el-form-item>
                <el-form-item label="院系：" prop="departName">
                    <el-input v-model="talentForm.departName" :disabled="true" class="talentTitle"></el-input>
                </el-form-item>
                <el-form-item label="发视频功能：" prop="videoEnable">
                    <el-switch v-model="talentForm.videoEnable" on-text="" off-text=""></el-switch>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            let checkPhone = (rule, value, callback) => {
                let phoneTest = /^1[3456789]\d{9}$/;
                if (value && value.trim()) {
                    if (phoneTest.test(value)) {
                        callback();
                    } else {
                        callback(new Error("手机号格式错误！"));
                    }
                } else {
                    callback(new Error("输入不能为空"));
                }
            };

            return {
                talentForm: {
                    phoneNumber: '',
                    name: '',
                    zoneName: '',
                    departName: '',
                    videoEnable: true
                },
                rules: {
                    phoneNumber: [
                        { required: true, message: '请填写手机号！', trigger: 'blur' },
                        { validator: checkPhone }
                    ]
                },
                isCanSave: false,
                errorMsg: '',
                uid: ''
            }
        },
        mounted() {

        },
        methods: {
            sendPhoneToCheck() {
                var that = this;
                this.talentForm.name = '';
                this.talentForm.zoneName = '';
                this.talentForm.departName = '';
                this.isCanSave = false;

                this.$refs.talentForm.validate((valid) => {
                    if (valid) {
                        let url = that.$util.domain + '/talent/userDetail?phoneNumber=' + that.talentForm.phoneNumber;

                        that.$http({
                            method: "GET",
                            url: url
                        }).then(res => {
                            if (res.data.error == 10000) {
                                let preObj = res.data.data;
                                that.uid = preObj.uid;
                                that.talentForm.name = preObj.name;
                                that.talentForm.zoneName = preObj.zoneName;
                                that.talentForm.departName = preObj.gradeClass;
                                that.isCanSave = preObj.talent ? false : true;
                                that.errorMsg = preObj.talent ? '该手机号已有达人绑定，请修改' : '';
                            } else {
                                that.errorMsg = res.data.message;
                                that.$util.errorMsg(res.data.message)
                            }
                        })
                    }
                })
            },
            saveTalent() {
                var that = this;

                that.$refs.talentForm.validate((valid) => {
                    if (valid && that.isCanSave) {
                        let url = that.$util.domain + '/talent/add'

                        that.$http({
                            method: "POST",
                            url: url,
                            body: JSON.stringify({
                                uid: that.uid,
                                videoEnable: that.talentForm.videoEnable
                            })
                        }).then(res => {
                            if (res.data.error == 10000) {
                                location.href = "#/yunying/talent/talentManage"
                            } else {
                                that.$util.errorMsg(res.data.message)
                            }
                        }).catch(_ => {
                            that.$util.errorMsg('请求失败')
                        })
                    }
                })
            },
            cancel() {
                history.go(-1);
            },
        }
    }
</script>
<style scoped>
    .talentTitle {
        display: inline-block;
        width: 300px;
    }

    .err-msg {
        padding-left: 20px;
        color: red;
    }
</style>


// WEBPACK FOOTER //
// newTalent.vue?c7e9e010